import type { User } from "@/shared/types/Users/User";
import type { UserType } from "@/shared/types/Users/UserType";
import { defineStore } from "pinia";
import { ref } from "vue";
import deleteCookie from "@/shared/utils/deleteCookie";

export const useUserStore = defineStore("user", () => {
	const user = ref<User>();
	const userType = ref<UserType>();

	function setUser(newUser: User) {
		user.value = newUser;
	}

	function setUserType(newType: UserType) {
		userType.value = newType;
	}

	function setTwofaToken(token: string) {
		if (user.value) {
			user.value.twofaToken = token;
			localStorage.setItem("user", JSON.stringify(user.value));
		}
	}

	function logout() {
		user.value = undefined;
		localStorage.removeItem("user");
		localStorage.removeItem("userType");
		deleteCookie("access_token");
		deleteCookie("refresh_token");
		window.location.reload();
		window.location.href = "/login";
	}

	return { user, setUser, logout, userType, setUserType, setTwofaToken };
});
